import {
  manager,
  axios
} from './api'

function createAXIOSObj(link, params) {
  let ax = axios.create({
    baseURL: link,
    timeout: params.timeout ? params.timeout : 120000,
    withCredentials: false,
    headers: {
      'Accept': params.accept ? params.accept : null,
      'Content-Type': params.contentType ? params.contentType : null
    }
  });

  if (params.bearer != null) {
    ax.defaults.headers.common['Authorization'] = `Bearer ${val}`;
  }

  return ax;
}

export default {
  authenticate(username, password) {
    return new Promise((resolve, reject) => {
      manager.post('/login', {
        email: username,
        password: password,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          if (error.response) {
            return reject(error.response);
          } else if (error.request) {
            return reject(error.request);
          } else {
            return reject(error.message);
          }

        });
    });
  },

  reset(data) {
    return new Promise((resolve, reject) => {
      manager.post('/reset', data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          if (error.response) {
            return reject(error.response);
          } else if (error.request) {
            return reject(error.request);
          } else {
            return reject(error.message);
          }

        });
    });
  },

  config(token) {
    let val = (token != null) && (token.access_token != null) ? token.access_token : token;
    manager.defaults.headers.common['Authorization'] = `Bearer ${val}`;
  },

  logout() {
    return manager.post('/logout', {}, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });
  },

  all(requests, successes, errors) {
    axios.all(requests)
      .then(axios.spread(successes))
      .catch(errors);
  },

  custom: {
    get(link, params) {
      let ax = createAXIOSObj(link, params);
      return ax.get('');
    },
    post(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.post('', data);
    },
    put(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.put('', data);
    },
    patch(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.patch('', data);
    },
    delete(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.delete('', data);
    }
  },

  users: {
    get(id) {
      let uri = id != null ? `/users/${id.toString()}` : '/users';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    myPartners(id, q) {
      let uri = `/users/${id.toString()}/partners`;
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    myPartnersEmployees(id, ids) {
      let q = Array.isArray(ids) ? `uid[in]${ids.join(',')}[end]` : `uid[eq]${ids}[end]`,
        uri = `/users/${id.toString()}/partners/employees?q=${q}`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    myDetails(id) {
      let uri = `/users/${id.toString()}/details`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    mySettings(id) {
      let uri = `/users/${id.toString()}/settings`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    myCompany(id) {
      let uri = `/users/${id.toString()}/company`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/users';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    pushImages(id, data) {
      let uri = `/users/${id}/images`;
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {
      let uri = `/users/${id.toString()}`;
      return manager.put(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    patch(id, data) {
      let uri = `/users/${id.toString()}`;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    patchCompany(id, data) {
      let uri = `/users/${id.toString()}/company`;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    pushCompanyImages(id, data) {
      let uri = `/users/${id}/company/images`;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
        },
      });
    },
    delete(id) {
      let uri = `/users/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    execute(id, cmd) {
      let uri = `/users/${id.toString()}/commands`;
      return manager.post(uri, cmd, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    }
  },

  companies: {
    get(id) {
      let uri = id != null ? `/companies/${id.toString()}` : '/companies';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/companies';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {

    },
    delete(id) {

    },
  },

  requests: {
    get(id, q) {
      let uri = id != null ? `/requests/${id.toString()}` : '/requests';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    getByUid(uid, q) {
      let uri = uid != null ? `/requests/uid/${uid.toString()}` : '/requests';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    getSchedules(uid, q) {
      let uri = uid != null ? `/requests/schedules/${uid.toString()}` : '/requests/schedules';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/requests';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    downloadLink(uid) {
      let uri = `/requests/links/${uid}`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    uploadLink(data) {
      let uri = '/requests/links';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {
      let uri = `/requests/${id.toString()}`;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    delete(id) {
      let uri = `/requests/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    execute(uid, cmd) {
      let uri = `/requests/${uid.toString()}/commands`;
      return manager.post(uri, cmd, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  dispatches: {
    get(id, q) {
      let uri = id != null ? `/dispatches/${id.toString()}` : '/dispatches';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    getSlots(q) {
      let uri = `/dispatches/slots?q=${q.toString()}`;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    getSchedules(uid, q) {
      let uri = uid != null ? `/dispatches/schedules/${uid.toString()}` : '/dispatches/schedules';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/dispatches';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {
      let uri = '/dispatches/' + id;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    delete(id) {
      let uri = `/dispatches/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    execute(uid, cmd) {
      let uri = `/dispatches/${uid.toString()}/commands`;
      return manager.post(uri, cmd, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  schedules: {
    get(id, q) {
      let uri = id != null ? `/schedules/${id.toString()}` : '/schedules';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/schedules';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    postRoundTrip(data) {
      let uri = '/schedules/roundtrips';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {

    },
    delete(id) {
      let uri = `/schedules/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  bundles: {
    get(id, q) {
      let uri = id != null ? `/bundles/${id.toString()}` : '/bundles';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/bundles';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {

    },
    delete(id) {
      let uri = `/bundles/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  amends: {
    get(id, q) {
      let uri = id != null ? `/amends/${id.toString()}` : '/amends';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/amends';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {

    },
    delete(id) {
      let uri = `/amends/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  forwards: {
    get(id, q) {
      let uri = id != null ? `/forwards/${id.toString()}` : '/forwards';
      uri = (q != null) && (q.toString().trim() != '') ? `${uri}?q=${q}` : uri;
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/forwards';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {

    },
    patch(id, data) {

    },
    delete(id) {
      let uri = `/forwards/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  vehicles: {
    get(id) {
      let uri = id != null ? `/vehicles/${id.toString()}` : '/vehicles';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    post(data) {
      let uri = '/vehicles';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    put(id, data) {
      let uri = `/vehicles/${id.toString()}`;
      return manager.put(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    patch(id, data) {
      let uri = `/vehicles/${id.toString()}`;
      return manager.patch(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
    delete(id) {
      let uri = `/vehicles/${id.toString()}`;
      return manager.delete(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  resources: {
    get(id) {
      let uri = id != null ? `/resources/${id.toString()}` : '/resources';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  permissions: {
    get(id) {
      let uri = id != null ? `/permissions/${id.toString()}` : '/permissions';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  notifications: {
    get(id) {
      let uri = id != null ? `/notifications/${id.toString()}` : '/notifications';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  equipmentsType: {
    get(id) {
      let uri = id != null ? `/equipments/${id.toString()}` : '/equipments';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  vehiclesType: {
    get(id) {
      let uri = id != null ? `/vehicleTypes/${id.toString()}` : '/vehicleTypes';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  groups: {
    get(id) {
      let uri = id != null ? `/groups/${id.toString()}` : '/groups';
      return manager.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },

  demo: {
    post(id, data) {
      let uri = '/demo';
      return manager.post(uri, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },
}
